import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { IoMdArrowBack } from "react-icons/io";
import {
  Button,
  Card,
  Container,
  Form,
  Input,
  Label,
  Spinner,
} from "reactstrap";
import cross from "../../assets/img/cross.svg";
import { useDispatch, useSelector } from "react-redux";
import { createContractRequest } from "store/actions/requestSchoolContractsAction";
import { fetchSchoolStates } from "store/actions/athleteActions";
import { getSchoolCounty } from "store/actions/athleteActions";
import { newSchoolsData } from "store/actions/newSchoolsAction";
import { Autocomplete, TextField } from "@mui/material";
import { isExitContract } from "store/actions/requestSchoolContractsAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import img from "../../assets/img/custom/contractImg.png";
import { fetchStates } from "store/actions/athleteActions";
import { getCollegeCity } from "store/actions/athleteActions";
import { newCollegeUniversities } from "store/actions/newCollegeUniversities";
import InstituteRegistrationModal from "components/InstituteRegistrationModal";

const RequestSchoolContracts = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [image, setImage] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [college, setCollege] = useState("");
  const [newSchool, setNewSchool] = useState("");
  const [btnLoader, setBtnLoader] = useState(false);
  const [contractLevel, setContractLevel] = useState("College contract");
  const { states, schoolStates, counties, cities } = useSelector(
    (state) => state.athlete
  );
  const { newSchoolsAllData } = useSelector((state) => state.schools);
  const { newCollegeUniversitiesData } = useSelector(
    (state) => state.collegeAndUniversities
  );
  useEffect(() => {
    if (state != "" && college != "") {
      if (contractLevel == "College contract") {
        dispatch(newCollegeUniversities(state, college));
      } else {
        dispatch(newSchoolsData(state, college));
      }
    }
  }, [state, college]);

  useEffect(() => {
    dispatch(fetchStates());
    dispatch(fetchSchoolStates());
  }, []);
  useEffect(() => {
    if (state != "") {
      if (contractLevel == "College contract") {
        dispatch(getCollegeCity(state));
      } else {
        dispatch(getSchoolCounty(state));
      }
    }
  }, [state]);

  const defaultStateProps = {
    options:
      contractLevel == "College contract"
        ? states?.map((insti) => {
            return insti.name;
          })
        : schoolStates?.map((insti) => {
            return insti.name;
          }),
    getOptionLabel: (option) => option,
  };
  const defaultCollegeProps = {
    options:
      contractLevel === "College contract"
        ? [...(cities?.map((insti) => insti.city) ?? [])]
        : [...(counties?.map((insti) => insti.county) ?? [])],
    getOptionLabel: (option) => option,
  };

  let newSchools = [];
  const getInstitutes = () => {
    if (contractLevel == "College contract") {
      newCollegeUniversitiesData?.forEach((insti) => {
        insti.institutes?.forEach((ele) => {
          if (ele !== "OTHER") {
            newSchools.push(ele);
          }
        });
      });
    } else {
      newSchoolsAllData.forEach((insti) => {
        insti.institutes?.forEach((ele) => {
          if (ele !== "OTHER") {
            newSchools.push(ele);
          }
        });
      });
    }
    if (newSchools) {
      return newSchools;
    }
  };
  const defaultNewSchoolProps = {
    options: getInstitutes(),
    getOptionLabel: (option) => option,
  };
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoader(true);
    const obj = {
      email: email,
      image: image,
      state: state,
      country: college,
      school: newSchool,
      type: contractLevel,
    };
    dispatch(
      isExitContract(obj, (ref) => {
        if (ref == "success") {
          dispatch(
            createContractRequest(obj, () => {
              setEmail("");
              setState("");
              setCollege("");
              setNewSchool("");
              setImage("");
              setBtnLoader(false);
              history.push("/home");
            })
          );
        } else {
          setBtnLoader(false);
        }
      })
    );
  };

  const [isRegistrationModalOpen, setRegistrationModalOpen] = useState(false);

  const requestRegistration = () => {
    setRegistrationModalOpen(!isRegistrationModalOpen);
  };

  return (
    <div className="bg-white px-2 px-sm-5">
      <div
        className="py-4 d-md-flex justify-content-around
    align-items-center"
      >
        <button type="button" className="text-white btn btn-primary text-nowrap" onClick={() => window.history.back()}>
          <IoMdArrowBack /> Go Back
        </button>
        <h2 className="ml-md-4 mt-4 mt-md-0">
          If you don't find your city/county and institute listed, please{" "}
          <span
            className="btn btn-primary btn-sm"
            onClick={requestRegistration}
          >
            click here
          </span>{" "}
          to request registration for a new school.
        </h2>
      </div>
      <Container className="contract_section">
        <div className="my-2 text-center">
          <a
            href="https://youtu.be/-czWzFbJSh0
"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://youtu.be/-czWzFbJSh0
          </a>
        </div>
        <p>
          For Institutions wishing to <b>enhance their ATHLETICS programs</b> ,
          FHP offers the following:
        </p>
        <div className="my-4">
          <ol tye="1" className="pl-3">
            <li>
              <span className="ml-2">
                Authorized officials within your Institution can apply here to
                review FHP’s standard contract for IP rights.
              </span>
            </li>
            <li>
              <span className="ml-2">
                By terms of this contract, your{" "}
                <b>
                  Institution will be able to select which IP rights to license
                </b>{" "}
                to FHP for FHP’s Brand Ambassador student athletes use in
                preparing and presenting FHP brand products and services.
              </span>
            </li>
            <li>
              <span className="ml-2">
                The goal is to enhance benefits to your Institution in terms of
                visibility and quality of your ATHLETICS PROGRAM, while under
                your guidance allowing your student athletes to exercise their
                rights under the specific NIL laws and guidelines which apply.
                This{" "}
                <b>
                  Offer is void if in conflict with Federal/State law, local
                  regulations, or school policy.
                </b>
              </span>
            </li>
            <li>
              <span className="ml-2">
                The steps to take if your circumstances permit (High School.
                College, or University) are as follows:
                <ol type="A">
                  <li>
                    <span>
                      Select an official to serve as{" "}
                      <b>School Verification Officer (SVO)</b> for the program
                      at your Institution.
                    </span>
                  </li>
                  <li>
                    <span>
                      Direct the SVO to submit a{" "}
                      <b>digital copy of his or her school ID</b> and email
                      address within school email system.
                    </span>
                  </li>
                  <li>
                    <span>
                      FHP will verify the credentials, then{" "}
                      <b>send the SVO a link to the IP rights contract</b> so
                      your Institution can review.
                    </span>
                  </li>
                  <li>
                    <span>
                      As SVO will note in Schedule B, a{" "}
                      <b>
                        clickable menu of IP rights for your Institution’s
                        selection
                      </b>{" "}
                      is available.
                    </span>
                  </li>
                  <li>
                    <span>
                      When your Institution has completed and signed the
                      contract online, please click the ‘submit’ button.
                    </span>
                  </li>
                </ol>
              </span>
            </li>
          </ol>
        </div>
      </Container>
      <Card className="py-4 shadow">
        <Container>
          <Label className="mt-3 auth-label">
            Click for College or High School contract
          </Label>
          <div className="d-flex ml-4  mt-2 mb-4">
            <div>
              <Input
                type="radio"
                checked={contractLevel == "College contract"}
                id="d_yes"
                name="contractLevel"
                value="College contract"
                onChange={(e) => {
                  setContractLevel(e.target.value);
                  setState("");
                  setCollege("");
                  setNewSchool("");
                }}
              />
              <Label
                for="d_yes"
                className={`auth-label ${
                  contractLevel == "College contract" ? "text-primary" : ""
                }`}
              >
                College contract
              </Label>
            </div>
            <div className="mx-auto">
              <Input
                type="radio"
                id="d_no"
                name="contractLevel"
                checked={contractLevel == "High School contract"}
                value="High School contract"
                onChange={(e) => {
                  setContractLevel(e.target.value);
                  setState("");
                  setCollege("");
                  setNewSchool("");
                }}
              />
              <Label
                for="d_no"
                className={`auth-label ${
                  contractLevel == "High School contract" ? "text-primary" : ""
                }`}
              >
                High School contract
              </Label>
            </div>
          </div>

          <Label className="mt-2 auth-label">
            Address Where
            {contractLevel == "College contract" ? " College" : " School"}
            Located
          </Label>
          <br />
          <div className="d-sm-flex">
            <div className="col-sm-4">
              <Label className="auth-label mt-3">State</Label>
              <Autocomplete
                {...defaultStateProps}
                id="auto-complete"
                autoComplete
                includeInputInList
                value={state}
                onChange={(e, val) => {
                  setState(val);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="State"
                    variant="standard"
                  />
                )}
              />
            </div>
            <div className="col-sm-4">
              <Label className="auth-label mt-3">
                {contractLevel == "College contract" ? "City" : "County"}
              </Label>
              <Autocomplete
                {...defaultCollegeProps}
                id="auto-complete-college"
                autoComplete
                includeInputInList
                disabled={!state}
                value={college}
                onChange={(e, val) => {
                  if (val === "OTHER") {
                    setCollege(val);
                    setNewSchool("OTHER");
                  } else {
                    setCollege(val);
                    setNewSchool("");
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={"County"}
                    variant="standard"
                  />
                )}
              />
            </div>
            <div className="col-sm-4">
              <Label className="auth-label mt-3">School</Label>
              <Autocomplete
                {...defaultNewSchoolProps}
                id="auto-complete-school"
                autoComplete
                includeInputInList
                value={newSchool}
                disabled={!state || !college}
                onChange={(e, val) => setNewSchool(val)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select your School from Dropdown menu"
                    variant="standard"
                    inputProps={{
                      ...params.inputProps,
                      readOnly: true,
                    }}
                  />
                )}
              />{" "}
            </div>
          </div>
        </Container>
        <Container className="text-center">
          <h2 className="mt-5">Request For Contract</h2>
          <Form
            onSubmit={handleSubmit}
            className="d-flex flex-column align-items-center mt-5"
          >
            <div className="col-sm-5 mb-3 d-flex flex-column align-items-start">
              <Label className="auth-label">Email</Label>
              <Input
                required
                placeholder="name@gmail.com"
                type="email"
                className="custom-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="col-sm-5 d-flex flex-column align-items-start">
              <Label className="auth-label mt-4">Upload ID</Label>
              <Input
                type="file"
                required
                ref={fileInputRef}
                name="player_img"
                accept="image/png, image/gif, image/jpeg"
                onChange={(e) => setImage(e.target.files[0])}
              />
              {image && (
                <div className="position-relative mt-3">
                  <img
                    src={URL?.createObjectURL(image)}
                    alt=""
                    className=" mt-2"
                    width={80}
                    height={80}
                  />
                  <img
                    src={cross}
                    width={20}
                    alt=""
                    className="position-absolute"
                    style={{
                      top: "-11%",
                      left: "80%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setImage("");
                      if (fileInputRef.current) {
                        fileInputRef.current.value = null;
                      }
                    }}
                  />
                </div>
              )}
            </div>
            <Button
              type="submit"
              color="primary"
              className="mt-5"
              disabled={
                !email ||
                !image ||
                !state ||
                !college ||
                !newSchool ||
                btnLoader
              }
            >
              {btnLoader ? <Spinner size="sm" /> : "Submit"}
            </Button>
          </Form>
        </Container>
      </Card>
      <div className="img-div">
        <img src={img} alt="img" />
      </div>
      <InstituteRegistrationModal
        isOpen={isRegistrationModalOpen}
        toggle={requestRegistration}
      />
    </div>
  );
};

export default RequestSchoolContracts;
